import { Controller } from "@hotwired/stimulus"

// Affiche le header fixe quand le sentinel (#profile_image_header) sort de l'écran au scroll,
// et le cache à nouveau (avec transition) quand le sentinel redevient visible.
export default class extends Controller {
  static targets = ["header", "scrollContainer", "sentinel"]

  connect() {
    this.scrollContainer = this.hasScrollContainerTarget
      ? this.scrollContainerTarget
      : this.element.querySelector("main")
    this.sentinel = this.hasSentinelTarget
      ? this.sentinelTarget
      : document.getElementById("profile_image_header")

    if (!this.headerTarget || !this.scrollContainer || !this.sentinel) return

    this.observer = new IntersectionObserver(
      (entries) => this.observe(entries),
      {
        root: this.scrollContainer,
        rootMargin: "0px",
        threshold: 0
      }
    )
    this.observer.observe(this.sentinel)
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.hideTimeout) clearTimeout(this.hideTimeout)
  }

  observe(entries) {
    const entry = entries[0]
    if (!entry || !this.headerTarget) return

    if (entry.isIntersecting) {
      this.hideHeader()
    } else {
      this.showHeader()
    }
  }

  showHeader() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
    const header = this.headerTarget
    header.removeAttribute("aria-hidden")
    header.classList.remove("hidden")
    // Keep opacity-0 -translate-y-full for one frame so transition runs from that state
    requestAnimationFrame(() => {
      header.classList.remove("opacity-0", "-translate-y-full", "pointer-events-none")
      header.classList.add("opacity-100", "translate-y-0")
    })
  }

  hideHeader() {
    const header = this.headerTarget
    header.classList.add("opacity-0", "-translate-y-full", "pointer-events-none")
    header.classList.remove("opacity-100", "translate-y-0")

    if (this.hideTimeout) clearTimeout(this.hideTimeout)
    this.hideTimeout = setTimeout(() => {
      this.hideTimeout = null
      header.classList.add("hidden")
      header.setAttribute("aria-hidden", "true")
    }, 300)
  }
}
